import {FormControl, FormField, FormItem, FormLabel} from "@/components/ui/form";
import {cn} from "@/lib/utils";
import {Select, SelectContent, SelectItem, SelectTrigger, SelectValue} from "@/components/ui/select";
export default function CWFSelect({control, name, className, label, placeholder,items, ...props}){
    return(
        <FormField
            control={control}
            name={name}
            render={({field}) => (
                <FormItem className={cn("grid w-full items-center h-max gap-1.5 space-y-0", className)}>
                    {label && <FormLabel>{label}</FormLabel>}

                        <Select
                            onValueChange={field.onChange}
                            value={field.value ?? undefined}
                        >
                            <FormControl>
                                <SelectTrigger>
                                    <SelectValue placeholder={ placeholder ?? label ?? undefined} />
                                </SelectTrigger>
                            </FormControl>
                            <SelectContent>
                                {items.map(function(item){
                                    return <SelectItem key={item.id} value={item.id.toString()}>{item.value}</SelectItem>
                                })}
                            </SelectContent>
                        </Select>

                </FormItem>
            )}
        />
    )
}